import { useRouter } from 'next/router';
import HeadPage from '@/components/Common/Head';
import { Header, RoadMapItems } from '@/components/GameRoadMap';
import useMeta from '@/hooks/useMeta/useMeta';

const RoadMap = () => {
  const router = useRouter();
  const metaTags = useMeta(router.pathname);

  return (
    <div className='flex flex-col'>
      {metaTags !== undefined && (
        <HeadPage title={metaTags.title} description={metaTags.description} imageUrl={metaTags.imageUrl} isHome={metaTags.isHome} />
      )}
      <div>
        <div>
          <div className='mt-[0px] '>
            <Header />
            <RoadMapItems />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadMap;
